import workspaceQuery from 'graphql/queries/vat/VatTransactionWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/vat/VatTransactionListQuery.graphql';
import instanceQuery from 'graphql/queries/vat/VatTransactionQuery.graphql';
import defaultQuery from 'graphql/queries/vat/VatTransactionDefault.graphql';
import fragment from 'graphql/fragments/vat/VatTransactionFragment.graphql';
import aggregateQuery from 'graphql/queries/vat/VatTransactionAggregateQuery.graphql';
import { workspaceActionsForPermissions } from '../../../actions/vat/VatTransactionWorkspaceAction';

const VatTransaction = {
  type: 'VatTransaction',
  title: 'VAT Transactions',
  formTitle: 'VAT Transaction',
  formUrl: '/Vat/VatTransaction/Details/',
  workspaceUrl: '/Vat/VatTransaction/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'VAT_TRANSACTIONS',
  operations: 0,
  actions: [...workspaceActionsForPermissions],
};

export default VatTransaction;
